module.exports = __webpack_public_path__ + "img/as-janelas-verdes.9cdef13c.jpg";